import { ThemedProfilePage as Profile } from "./profile";
export const ThemedProfilePage = Profile;
